import Image from 'next/image';
import { useMediaQuery } from 'react-responsive';
import styles from './healthcare-intro.module.css';
import apple from '../../public/healthcare/intro/apple.webp';
import pill1 from '../../public/healthcare/intro/pill1.webp';
import pill2 from '../../public/healthcare/intro/pill2.webp';
import pill3 from '../../public/healthcare/intro/pill3.webp';
import dumbbell from '../../public/healthcare/intro/dumbbell.webp';
import stethoscope from '../../public/healthcare/intro/stethoscope.webp';
import tablet from '../../public/healthcare/intro/tablet.webp';
import { useMounted } from '../../hooks';
import { Container } from '../../components';

export default function HealthcareIntro() {
  const isTablet = useMediaQuery({ maxDeviceWidth: 1023 });
  const mounted = useMounted();

  const decorImage = isTablet
    ? 'healthcare/intro/mobile-line.svg'
    : 'healthcare/intro/line.svg';

  return (
    <section className={styles.intro}>
      <Container>
        <h1 className={styles.intro__title}>
          We&apos;re Experts in Healthcare Software Development
        </h1>
      </Container>
      <div className={styles.intro_inner}>
        <Container>
          <div className={styles.intro_container}>
            <p className={styles.intro__text}>
              MAVINX offers all-round services in building software solutions
              for the Healthcare industry. Whether you&apos;re creating your
              project from scratch, improving it, or need our help with just
              giving you a right direction to start, we&apos;re your reliable
              partner with the relevant Healthcare expertise. And this case
              proves it.
            </p>
            <div className={styles.wrapperMobile}>
              <div className={styles.intro_pill1}>
                <Image
                  unoptimized
                  width={123}
                  height={96}
                  priority
                  src={pill1.src}
                  quality={100}
                  alt="pill"
                />
              </div>
              <div className={styles.intro_pill2}>
                <Image
                  unoptimized
                  width={97}
                  height={89}
                  priority
                  src={pill2.src}
                  quality={100}
                  alt="pill"
                />
              </div>
              <div className={styles.intro_dumbbell}>
                <Image
                  unoptimized
                  width={339}
                  height={251}
                  priority
                  src={dumbbell.src}
                  quality={100}
                  alt="dumbbell"
                />
              </div>
              <div className={styles.intro_pill3}>
                <Image
                  unoptimized
                  width={94}
                  height={84}
                  priority
                  src={pill3.src}
                  quality={100}
                  alt="pill"
                />
              </div>
              <div className={styles.intro_stethoscope}>
                <Image
                  unoptimized
                  width={508}
                  height={604}
                  priority
                  src={stethoscope.src}
                  quality={100}
                  alt="stethoscope"
                />
              </div>
              <div className={styles.intro_tablet}>
                <Image
                  unoptimized
                  width={92}
                  height={100}
                  priority
                  src={tablet.src}
                  quality={100}
                  alt="tablet"
                />
              </div>
              <div className={styles.intro_apple}>
                <Image
                  unoptimized
                  width={170}
                  height={195}
                  priority
                  src={apple.src}
                  quality={100}
                  alt="apple"
                />
              </div>
              {mounted && (
                <img
                  className={styles.intro_line}
                  src={decorImage}
                  alt="decor line"
                />
              )}
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}
